import { ContentsUnion } from '@elearning-platform/api-types/interfaces';

import { contentHashRoutes } from '../consts';
import { AppLanguage } from '../enums';
import { HashRoute } from '../modules/knowledgeBaseV2/interfaces';

export const getContentHash: (item: ContentsUnion, language: AppLanguage) => string | undefined = (
  item: ContentsUnion, language: AppLanguage
): string | undefined => {
  const route: HashRoute | undefined = contentHashRoutes[language].find(
    (hashRoute: HashRoute): boolean => hashRoute.type === item.type
  );

  return route ? `${route.prefix}=${item.id}` : undefined;
};
